import { getChannelInfo, getUserInfo, PostInfo, getGlobalSetting } from '@/api/apiAll'
import QuickStorage from '@/utils/QuickStorage/index'
import gray from '@/utils/gray'

const actions = {
  async get_control({ state, commit, dispatch }, obj) {
    await Promise.all([
      dispatch('get_channerInfo', {
        id: obj.id
      })
    ])
  },
  async get_channerInfo({ state, commit, dispatch }, obj) {
    const res = await getChannelInfo({
      id: obj.id
    })
    if (res.code === 200 && res.errorCode === 0) {
      commit('set_channelInfo', res.data)
      dispatch('get_menuList')
      dispatch('get_advertList')
      dispatch('get_userInfo')
    } else {
      if (res.errorCode === 1) {
        commit('set_status', 404)
      }
    }
  },
  async get_menuList({ state, commit }, list) {
    const channelInfo = state.channelInfo
    commit('set_menuList', channelInfo.menuList)
  },
  async get_advertList({ state, commit, dispatch }) {
    const channelInfo = state.channelInfo
    const advertTop = {
      status: !!(channelInfo.topImgList && channelInfo.topImgList.length),
      list: channelInfo.topImgList || [],
      close: channelInfo.topForceShow
    }
    const advertMiddle = {
      status: !!(channelInfo.middleImgList && channelInfo.middleImgList.length),
      list: channelInfo.middleImgList || [],
      close: channelInfo.middleForceShow
    }
    commit('set_advertTop', advertTop)
    commit('set_advertMiddle', advertMiddle)
  },
  async get_userInfo({ state, commit, dispatch }) {
    const res = await getUserInfo({
      uin: state.channelInfo.uin
    })
    if (res.code === 200 && res.errorCode === 0) {
      commit('set_userInfo', res.data)
    }
    dispatch('PostInfo')
  },
  async PostInfo({ state }) {
    await PostInfo({
      channelId: state.channelInfo.id,
      uin: state.channelInfo.uin,
      userId: state.userInfo.id || 0,
      type: 3, // piclive
      deviceid: QuickStorage.localGet('DEVICE_ID')
    })
  },
  async get_globalSetting({ state, commit }) {
    const res = await getGlobalSetting({
      uin: state.channelInfo.uin,
    });
    if (res.code === 200 && res.errorCode === 0) {
      commit('set_globalSetting', res.data);
      if (res.data.blackWhiteMode === 1) {
        gray()
      }
    }
  },
}
export default actions
